import { Component, Input, OnInit } from '@angular/core';
import { ProjectRegistrationHelper } from '../project.registration.helper';
import { ProjectService } from '../../../../services/project.service';
import { UserService } from '../../../../services/core.user.service';
import { UntypedFormGroup } from '@angular/forms';

@Component({
	selector: 'project-registration-main',
	template: require('./project.registration.main.html'),
})
export class ProjectRegistrationMainComponent implements OnInit {
	captchaRefresh: any;
	parentProject: any = null;
	@Input() projectForm: UntypedFormGroup;

	isSiteAdmin: boolean = false;
	showTemplateToggle: boolean = false;
	unixNameChecking: boolean = false;
	unixNameAvailable: boolean | null = null;

	constructor(
		protected projectRegistrationHelper: ProjectRegistrationHelper,
		private projectService: ProjectService,
		private userService: UserService
	) { }

	ngOnInit(): void {
		// Initial enabled state for "Create Template" toggle
		this.isSiteAdmin = this.userService.isSiteAdmin();
		this.setShowTemplateToggle(this.projectForm.get('parentProjectId')?.value);
	}

	setFormValue(fieldName: string, value: any) {
		const patch = {};
		patch[fieldName] = value;
		return this.projectForm.patchValue(patch);
	}

	setShowTemplateToggle(parentProjectId): void {
		if (this.isSiteAdmin) {
			this.showTemplateToggle = true;
			return;
		}

		if (!parentProjectId) {
			this.showTemplateToggle = false;
			return;
		}

		this.projectService
			.search({ id: parentProjectId, isAdmin: true })
			.then(
				(response: any) => {
					this.showTemplateToggle = (response?.id == parentProjectId);
				},
				() => {
					this.showTemplateToggle = false;
				}
			);
	}

	setParentProjectId(org: any): void {
		this.projectForm.patchValue({
			parentProject: org,
			parentProjectId: org?.project || null
		});
		this.setShowTemplateToggle(
			this.projectForm.get('parentProjectId')?.value
		);
	}

	setTemplateProject(project: any): void {
		const id = project?.id;
		if (!id) {
			return this.projectForm.patchValue({
				templateProjectId: 0,
			});
		}

		this.projectService.modules(id).then(
			(modules: any) => {
				if (modules?.items) {
					this.projectForm.patchValue({
						modules: modules?.items.join(','),
					});
				}
			},
			() => { }
		);
	}
}